export default __webpack_public_path__ + "3640cc7405ecfe3d5b5d1837cf3b080a.png";